import React, { useEffect, useState } from "react";
import LessonCard from "../../../../components/PopUps/Schedule/LessonCard";
import { BackwardArrow } from "../../../../constant/imagePath";
import Colors from "../../../../stories/assets/Colors";
import Fonts from "../../../../stories/assets/Fonts";
import { ConfirmBookingLessonCard } from "../../../../stories/ConfirmBookingLessonCard/ConfirmBookingLessonCard";
import { LinkButtonWithIcon } from "../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import classes from "./ConfirmBookingLessonPage.module.css";

import { useHistory } from "react-router-dom";
import { Radio } from "../../../../stories/Radio/Radio";
import { TextArea } from "../../../../stories/TextArea/TextArea";
import { Input } from "../../../../stories/Input/Input";
import { Checkbox } from "../../../../stories/Checkbox/Checkbox";
import { isMobileViewHook } from "../../../../CustomHooks/isMobileViewHook";
import MobileBookingLessonPage from "./MobileBookingLessonPage";
import CancellationPolicyModal from "../../../../components/Modals/Admin/CancellationPolicyModal/CancellationPolicyModal";
import RequirementsModal from "../../../../components/Modals/Admin/RequirementsModal/RequirementsModal";
import BookingRequestedModal from "../../../../components/Modals/Admin/BookingRequestedModal/BookingRequestedModal";
import ErrorOccurModal from "../../../../components/Modals/Admin/ErrorOccurModal/ErrorOccurModal";
import { AfterLoginHeader } from "../../../../stories/AfterLoginHeader/AfterLoginHeader";
import { Footer } from "../../../../stories/Footer/Footer";

const BookingLessonDesktop = () => {
  const [cardNumber, setCardNumber] = useState("");
  const [cardholderName, setCardholderName] = useState("");
  const [expiryDate, setExpiryDate] = useState("");
  const [cvc, setCvc] = useState("");

  const [fullName, setFullName] = useState("");
  const [ageState, setAgeState] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");

  const [cardNumber1, setCardNumber1] = useState("");
  const [cardholderName1, setCardholderName1] = useState("");
  const [expiryDate1, setExpiryDate1] = useState("");
  const [cvc1, setCvc1] = useState("");
  const [addNotes, setAddNotes] = useState('')

  const history = useHistory();

  const [radioState, setRadioState] = useState("I’m booking it for myself");
  const [checkBoxState, setCheckBoxState] = useState();
  const [checkBoxState1, setCheckBoxState1] = useState();

  const [isCancellationModalOpen, setIsCancellationModalOpen] = useState(false);
  const [isRequirementsModalOpen, setIsRequirementsModalOpen] = useState(false);
  const [isBookingRequestedModalOpen, setIsBookingRequestedModalOpen] =
    useState(false);
  const [isErrorOccurenceModalOpen, setIsErrorOccurenceModalOpen] =
    useState(false);

  const [paymentDetailsRadioState, setPaymentDetailsRadioState] = useState(
    "Visa •••• 3679 (expires 12/24)"
  );

  return (
    <>
      <div
        className={classes.header}
        style={{
          borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}`,
          background: Colors.white,
        }}
      >
        <AfterLoginHeader />
      </div>
      <div
        className={`container-fluid ${classes.styled_container} ${classes.container}`}
      >
        <div className="row">
          <div className="col-xxl-8 col-xl-7 col-lg-6 col-md-6">
            <LinkButtonWithIcon
              primary={false}
              leftIcon={BackwardArrow}
              text={"Go Back"}
              onClick={() => history.goBack()}
            />
            <div>
              <h1
                style={{
                  ...Fonts.h1,
                  color: Colors.neutralShadesOfNero,
                  fontSize: 36,
                  fontWeight: "bold",
                  marginBottom: 15,
                }}
              >
                Confirm and pay
              </h1>
              <p
                style={{
                  ...Fonts.h1,
                  color: Colors.neutralShadesOfNero,
                  fontSize: 19,
                  fontWeight: "bold",
                  lineHeight: "34px",
                }}
              >
                <b>What's Provided</b>
              </p>
              <p
                style={{
                  ...Fonts.p,
                  color: Colors.neutralShadesOfNero,
                  fontSize: 16,
                  lineHeight: "24px",
                  marginBottom: 30,
                }}
              >
                There are things you should have when coming to a lesson. See
                what's provided by your coach and be sure to bring everything
                else.{" "}
                <b
                  style={{
                    ...Fonts.p1,
                    color: Colors.mainBlue,
                    fontSize: 19,
                    fontWeight: "bold",
                    lineHeight: "24px",
                    fontSize: 16,
                  }}
                >
                  Learn More
                </b>
              </p>
              <p
                style={{
                  ...Fonts.h1,
                  color: Colors.neutralShadesOfNero,
                  fontSize: 19,
                  fontWeight: "bold",
                  lineHeight: "44px",
                }}
              >
                <b>Who are you booking the lesson for?</b>
              </p>
              <div className={classes.radios}>
                <Radio
                  value={radioState}
                  setValue={setRadioState}
                  label={"I’m booking it for myself"}
                />

                <Radio
                  value={radioState}
                  setValue={setRadioState}
                  label={"I’m booking it for someone else"}
                />
              </div>
            </div>

            <div>
              {radioState === "I’m booking it for myself" ? (
                <div className={classes.mt32}>
                  <TextArea label={"Add notes (optional)"}
                    state={addNotes}
                    setter={setAddNotes}
                  />
                  <h1
                    style={{
                      ...Fonts.h1,
                      color: Colors.neutralShadesOfNero,
                      fontSize: 36,
                      lineHeight: "46px",
                      marginTop: 40,
                      fontWeight: "bold",
                    }}
                  >
                    Payment Details
                  </h1>
                  <p
                    style={{
                      ...Fonts.p,
                      color: Colors.neutralShadesOfNero,
                      fontSize: 16,
                      lineHeight: "24px",
                      marginBottom: 30,
                    }}
                  >
                    Payment will be charged after the lesson.
                  </p>
                  <div className={`row ${classes.rowMB}`}>
                    <div className="col-6">
                      <Input
                        type={"text"}
                        placeholder={"0000 0000 0000 0000"}
                        label={"Card number"}
                        state={cardNumber}
                        setter={setCardNumber}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        type={"text"}
                        placeholder={"Jonathan Moriarty"}
                        label={"Cardholder’s name"}
                        state={cardholderName}
                        setter={setCardholderName}
                      />
                    </div>
                  </div>
                  <div className={`row ${classes.rowMB}`}>
                    <div className="col-6">
                      <Input
                        placeholder={"MM/YY"}
                        type={"text"}
                        label={"Expiration date"}
                        state={expiryDate}
                        setter={setExpiryDate}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        placeholder={"3-digit number"}
                        type={"text"}
                        label={"CVC"}
                        state={cvc}
                        setter={setCvc}
                      />
                    </div>
                  </div>
                  <Checkbox
                    value={checkBoxState}
                    setValue={setCheckBoxState}
                    label={
                      "Save payment information to my account for future purchases"
                    }
                  />
                </div>
              ) : (
                <>
                  <div className={`row ${classes.rowMB} ${classes.rowT}`}>
                    <div className="col-12">
                      <Input
                        type={"text"}
                        placeholder={"Jonathan Moriarty"}
                        label={"Full Name"}
                        state={fullName}
                        setter={setFullName}
                      />
                    </div>
                  </div>
                  <div className={`row ${classes.rowMB}`}>
                    <div className="col-6">
                      <Input
                        placeholder={"14 years"}
                        type={"text"}
                        label={"Age"}
                        state={ageState}
                        setter={setAgeState}
                      />
                    </div>
                    <div className="col-6">
                      <Input
                        placeholder={"+1 (321) - 453 - 3325"}
                        type={"text"}
                        label={"Phone Number"}
                        state={phoneNumber}
                        setter={setPhoneNumber}
                      />
                    </div>
                  </div>
                  <div className={`row ${classes.rowMB}`}>
                    <div className="col-12">
                      <TextArea label={"Add notes (optional)"}
                        state={addNotes}
                        setter={setAddNotes}

                      />
                    </div>
                  </div>

                  <div className={`row ${classes.rowMB}`}>
                    <p
                      style={{
                        ...Fonts.h1,
                        color: Colors.neutralShadesOfNero,
                        fontSize: 19,
                        fontWeight: "bold",
                        lineHeight: "34px",
                      }}
                    >
                      <b>Payment Details</b>
                    </p>
                    <p>Payment will be charged after the lesson.</p>
                    <div className={classes.grid}>
                      <Radio
                        value={paymentDetailsRadioState}
                        setValue={setPaymentDetailsRadioState}
                        label={"Visa •••• 3679 (expires 12/24)"}
                      />

                      <Radio
                        value={paymentDetailsRadioState}
                        setValue={setPaymentDetailsRadioState}
                        label={"MasterCard •••• 2193 (expires 03/22)"}
                      />
                      <Radio
                        value={paymentDetailsRadioState}
                        setValue={setPaymentDetailsRadioState}
                        label={"New payment method"}
                      />
                    </div>
                    {paymentDetailsRadioState === "New payment method" ? (
                      <>
                        <div className={`row ${classes.rowMB} ${classes.rowT}`}>
                          <div className="col-6">
                            <Input
                              type={"text"}
                              placeholder={"0000 0000 0000 0000"}
                              label={"Card number"}
                              state={cardNumber1}
                              setter={setCardNumber1}
                            />
                          </div>
                          <div className="col-6">
                            <Input
                              type={"text"}
                              placeholder={"Jonathan Moriarty"}
                              label={"Cardholder’s name"}
                              state={cardholderName1}
                              setter={setCardholderName1}
                            />
                          </div>
                        </div>
                        <div className={`row ${classes.rowMB}`}>
                          <div className="col-6">
                            <Input
                              placeholder={"MM/YY"}
                              type={"text"}
                              label={"Expiration date"}
                              state={expiryDate1}
                              setter={setExpiryDate1}
                            />
                          </div>
                          <div className="col-6">
                            <Input
                              placeholder={"3-digit number"}
                              type={"text"}
                              label={"CVC"}
                              state={cvc1}
                              setter={setCvc1}
                            />
                          </div>
                        </div>
                        <div className={`row ${classes.rowMB}`}>
                          <div className="col-12">
                            <Checkbox
                              value={checkBoxState1}
                              setValue={setCheckBoxState1}
                              label={
                                "Save payment information to my account for future purchases"
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              )}

              <hr />
              <p
                style={{
                  ...Fonts.h1,
                  color: Colors.neutralShadesOfNero,
                  fontSize: 19,
                  fontWeight: "bold",
                  lineHeight: "44px",
                  marginTop: 40,
                }}
              >
                <b>Cancellation Policy</b>
              </p>
              <p
                style={{
                  ...Fonts.p,
                  color: Colors.neutralShadesOfNero,
                  fontSize: 16,
                  lineHeight: "24px",
                }}
              >
                Free cancellation up to 24 hours before lesson starts. If you
                cancel a class less than 24 hours before the start of the
                lesson, the booking will not be refunded{" "}
                <b
                  style={{
                    ...Fonts.p1,
                    color: Colors.mainBlue,
                    fontSize: 19,
                    fontWeight: "bold",
                    lineHeight: "24px",
                    fontSize: 16,
                  }}
                >
                  Learn More
                </b>
              </p>
            </div>
          </div>
          <div className="col-xxl-4 col-xl-5 col-lg-6 col-md-6">
            <ConfirmBookingLessonCard
              cardNumber={cardNumber}
              cardholderName={cardholderName}
              expiryDate={expiryDate}
              cvc={cvc}
              checkBoxState={checkBoxState}
              paymentDetailsRadioState={paymentDetailsRadioState}
              fullName={fullName}
              ageState={ageState}
              phoneNumber={phoneNumber}
              checkBoxState1={checkBoxState1}
              setIsCancellationModalOpen={setIsCancellationModalOpen}
              setIsRequirementsModalOpen={setIsRequirementsModalOpen}
              setIsBookingRequestedModalOpen={setIsBookingRequestedModalOpen}
              setIsErrorOccurenceModalOpen={setIsErrorOccurenceModalOpen}
            />
          </div>
          {/* <CancellationPolicyModal
          show={isCancellationModalOpen}
          setShow={setIsCancellationModalOpen}
        /> */}
          {/* <RequirementsModal
          show={isRequirementsModalOpen}
          setShow={setIsRequirementsModalOpen}
        /> */}
          {/* <BookingRequestedModal
          show={isBookingRequestedModalOpen}
          setShow={setIsBookingRequestedModalOpen}
        /> */}
          <ErrorOccurModal
            show={isErrorOccurenceModalOpen}
            setShow={setIsErrorOccurenceModalOpen}
          />
        </div>
      </div>
      <Footer className={classes.container} />
    </>
  );
};

function BookingLesson() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => [isMobileViewHook(setIsMobile, 992)], []);

  return (
    <>{isMobile ? <MobileBookingLessonPage /> : <BookingLessonDesktop />}</>
  );
}

export default BookingLesson;
